module.exports = __webpack_public_path__ + "static/img/online_pic3.3e676e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online_pic3.jpg
// module id = 1J/D
// module chunks = 21